import React from 'react';
import RegistrationResultPage from './RegistrationResultPage';

const RegistrationSuccessPage = () => (
  <RegistrationResultPage
    status="success"
    heading="Registration Successful"
    details="Your account has been created successfully. You can now access FileXpress using your new credentials."
  />
);

export default RegistrationSuccessPage;
